/**
 * Builds the URL path segment for /government-trades/members/[slug].
 * Aligns with server-side matching in getGovernmentMemberProfilePageProps (data.tsx).
 */
export function memberDisplayNameToProfileSlug(displayName: string | null | undefined): string {
  if (!displayName) return '';
  return displayName.replaceAll('.', '').replaceAll(',', '').replaceAll(' ', '-').toLowerCase();
}

export function resolveMemberProfileSlugs(
  displayNames: readonly (string | null | undefined)[],
  members: readonly { filer_info?: { display_name?: string | null } | null }[],
): Record<string, string> {
  const known = new Set(members.map(member => member.filer_info?.display_name));
  const slugs: Record<string, string> = {};
  for (const displayName of displayNames) {
    if (displayName && known.has(displayName)) slugs[displayName] = memberDisplayNameToProfileSlug(displayName);
  }
  return slugs;
}
